import { Injectable } from '@angular/core';

import { RoutingService, GlobalMessageService, User, B2BUserRole, GlobalMessageType } from '@spartacus/core';
import { Observable } from 'rxjs';
import { filter, pluck, map, tap } from 'rxjs/operators';
import {UserAccountFacade} from '@spartacus/user/account/root';

@Injectable({
    providedIn: 'root',
})
export class UigBranchesGuard  {

    SHOW_BRANCHES = 'show_branches';
    MAIN_CONTACT_USER = 'ROLE_MAIN_CONTACT_USER';
    roles: string[];

    constructor(
        protected userAccountFacade: UserAccountFacade,
        protected routingService: RoutingService,
        protected globalMessageService: GlobalMessageService
    ) { }

    canActivate(): Observable<boolean> {
        return this.userAccountFacade.get().pipe(
            filter((user: User) => user && Object.keys(user).length > 0),
            tap((user) => {
                this.roles = user.roles;
            }),
            pluck('authorities'),
            map((authorities: string[]) => {
                const hasRole =
                    (authorities && Array.isArray(authorities) && authorities.includes(this.MAIN_CONTACT_USER))
                    || (this.roles && this.roles.includes(this.SHOW_BRANCHES));

                if (!hasRole) {
                    // routing as temporary solution until /organization won't
                    // have set up proper permission on backend
                    this.routingService.go({ cxRoute: 'organization' });

                    this.globalMessageService.add(
                        { key: 'organization.notification.noSufficientPermissions' },
                        GlobalMessageType.MSG_TYPE_WARNING
                    );
                }

                return hasRole;
            })
        );
    }
}
